var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 36 36",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ee1848",
    height: 36,
    rx: 18,
    width: 36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.962 14.3V22H11.5l-3.84-4.675V22H5.9v-7.7h1.474l3.826 4.675V14.3zm7.5 4.763q0 .033-.033.462h-4.475a1.394 1.394 0 00.572.869 1.9 1.9 0 001.122.319 2.272 2.272 0 00.819-.138 1.985 1.985 0 00.666-.434l.913.99a3.068 3.068 0 01-2.446.957 3.863 3.863 0 01-1.767-.388 2.863 2.863 0 01-1.188-1.086 2.985 2.985 0 01-.418-1.573 3.024 3.024 0 01.413-1.568 2.89 2.89 0 011.133-1.088 3.327 3.327 0 011.611-.391 3.3 3.3 0 011.573.374 2.73 2.73 0 011.106 1.073 3.2 3.2 0 01.401 1.622zm-3.067-1.771a1.478 1.478 0 00-.979.33 1.4 1.4 0 00-.484.9h2.915a1.419 1.419 0 00-.484-.9 1.447 1.447 0 00-.968-.33zM31 16.082L28.857 22h-1.65l-1.331-3.674L24.5 22h-1.649l-2.134-5.918h1.617l1.4 4 1.452-4h1.449l1.408 4 1.441-4z",
    fill: "#fff"
  })));
}

export default SvgIcnNew;